import React from 'react';
import { Helmet } from 'react-helmet-async';

const tiers = [
  {
    title: 'Silver • 0 – 999 pts',
    perks: ['5% savings on every order', 'Free standard shipping above ₹2,000', 'Early access to store-wide sales'],
  },
  {
    title: 'Gold • 1,000 – 4,999 pts',
    perks: [
      '10% savings automatically applied',
      'Free express shipping above ₹1,500',
      'Priority customer support',
      'Member-only product drops',
    ],
  },
  {
    title: 'Platinum • 5,000+ pts',
    perks: [
      '15% savings across the catalogue',
      'Complimentary overnight shipping',
      'Dedicated account manager',
      'First look at new launches',
      'Invites to professional training sessions',
    ],
  },
];

const Rewards = () => {
  return (
    <>
      <Helmet>
        <title>Rewards Program - Dental Stores</title>
        <meta
          name="description"
          content="Discover Dental Stores rewards program. Earn points on purchases and redeem them for exclusive benefits."
        />
      </Helmet>
      <div style={{ padding: '48px 24px 100px', maxWidth: '980px', margin: '0 auto', color: '#1f2933' }}>
        <header style={{ marginBottom: '48px' }}>
          <p
            style={{
              margin: 0,
              color: '#1565C0',
              fontWeight: '600',
              letterSpacing: '0.28em',
              textTransform: 'uppercase',
              fontSize: '12px',
            }}
          >
            Loyalty that pays back
          </p>
          <h1
            style={{
              fontSize: '38px',
              fontWeight: '700',
              margin: '12px 0 0',
              lineHeight: 1.25,
              color: '#102a43',
            }}
          >
            Dental Stores Rewards Program
          </h1>
          <p style={{ marginTop: '18px', fontSize: '17px', lineHeight: 1.7, maxWidth: '720px', color: '#52606d' }}>
            Earn points on every purchase and turn them into discounts, shipping perks, and exclusive experiences.
          </p>
        </header>

        <section style={{ display: 'grid', gap: '40px' }}>
          <article style={{ display: 'grid', gap: '18px' }}>
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#102a43' }}>How it works</h2>
            <ol style={{ margin: 0, paddingLeft: '20px', display: 'grid', gap: '12px', fontSize: '16px', color: '#1f2933' }}>
              <li>
                <strong>Sign up:</strong> Create a free Dental Stores account—membership activates automatically.
              </li>
              <li>
                <strong>Earn points:</strong> Collect 1 point for every ₹100 spent on eligible products, plus special
                bonuses.
              </li>
              <li>
                <strong>Redeem:</strong> Convert points into vouchers, shipping upgrades, or premium equipment.
              </li>
            </ol>
          </article>

          <article style={{ display: 'grid', gap: '16px' }}>
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#102a43' }}>Ways to earn faster</h2>
            <ul style={{ margin: 0, paddingLeft: '22px', display: 'grid', gap: '10px', fontSize: '16px', color: '#1f2933' }}>
              <li>
                <strong>Standard purchases:</strong> 1 point per ₹100.
              </li>
              <li>
                <strong>Birthday month:</strong> Double points on all orders.
              </li>
              <li>
                <strong>Referral bonus:</strong> 500 points when your referral places their first order.
              </li>
              <li>
                <strong>Product reviews:</strong> 50 points for every approved review.
              </li>
              <li>
                <strong>Social shares:</strong> 25 points for sharing featured products.
              </li>
            </ul>
          </article>

          <article style={{ display: 'grid', gap: '20px' }}>
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#102a43' }}>Membership tiers</h2>
            <div style={{ display: 'grid', gap: '18px', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
              {tiers.map((tier) => (
                <div
                  key={tier.title}
                  style={{
                    border: '1px solid #d9e2ec',
                    borderRadius: '16px',
                    padding: '24px',
                    background: 'linear-gradient(135deg, rgba(16,132,126,0.08), rgba(15,23,42,0.04))',
                    display: 'grid',
                    gap: '12px',
                  }}
                >
                  <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#102a43' }}>{tier.title}</h3>
                  <ul style={{ margin: 0, paddingLeft: '18px', display: 'grid', gap: '8px', fontSize: '15px', color: '#1f2933' }}>
                    {tier.perks.map((perk) => (
                      <li key={perk}>{perk}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </article>

          <article style={{ display: 'grid', gap: '16px' }}>
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#102a43' }}>Redeeming points</h2>
            <ul style={{ margin: 0, paddingLeft: '22px', display: 'grid', gap: '10px', fontSize: '16px', color: '#1f2933' }}>
              <li>
                <strong>₹50 voucher:</strong> 100 points.
              </li>
              <li>
                <strong>Free standard shipping:</strong> 200 points.
              </li>
              <li>
                <strong>Free express shipping:</strong> 300 points.
              </li>
              <li>
                <strong>Premium upgrades:</strong> Use points toward high-value equipment and supplies.
              </li>
            </ul>
            <p style={{ margin: 0, fontSize: '16px', color: '#52606d' }}>
              Points remain valid for 12 months from the date they are earned—redeem them before they expire.
            </p>
          </article>

          <article
            style={{
              backgroundColor: '#f8fafc',
              border: '1px solid #d9e2ec',
              borderRadius: '16px',
              padding: '24px',
              display: 'grid',
              gap: '12px',
            }}
          >
            <h2 style={{ margin: 0, fontSize: '22px', fontWeight: '600', color: '#102a43' }}>Promotions & bonuses</h2>
            <p style={{ margin: 0, fontSize: '16px', color: '#52606d' }}>
              Watch for seasonal double-point events, milestone bonuses, and referral drives—we announce them via email
              and the in-app notification center.
            </p>
          </article>

          <article style={{ display: 'grid', gap: '12px' }}>
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#102a43' }}>Program guidelines</h2>
            <ul style={{ margin: 0, paddingLeft: '22px', display: 'grid', gap: '8px', fontSize: '16px', color: '#1f2933' }}>
              <li>Rewards are linked to individual accounts and can't be transferred.</li>
              <li>Points have no cash value outside the program.</li>
              <li>Returned orders deduct the points originally earned.</li>
              <li>We'll always notify you before policy updates take effect.</li>
            </ul>
          </article>

          <article
            style={{
              border: '1px solid #d9e2ec',
              borderRadius: '16px',
              padding: '24px',
              display: 'grid',
              gap: '12px',
              textAlign: 'center',
            }}
          >
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#102a43' }}>Ready to start earning?</h2>
            <p style={{ margin: 0, fontSize: '16px', color: '#52606d' }}>
              Join thousands of dental professionals who already unlock extra savings with every order.
            </p>
            <div>
              <button
                type="button"
                style={{
                  padding: '14px 28px',
                  backgroundColor: '#1565C0',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '10px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              >
                Join Rewards Program
              </button>
            </div>
            <p style={{ margin: 0, fontSize: '14px', color: '#829ab1' }}>
              Need help? Email <strong>rewards@dentalstores.in</strong> or call +91 70931 34343.
            </p>
          </article>
        </section>
      </div>
    </>
  );
};

export default Rewards;
